import { render, staticRenderFns } from "./CustomerComplaintChooseOwner.vue?vue&type=template&id=1ab2a978&"
import script from "./CustomerComplaintChooseOwner.vue?vue&type=script&lang=js&"
export * from "./CustomerComplaintChooseOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports